import { BlotterDetailsField } from '@/App/Blotter/grids/details/BlotterDetailsField.tsx';
import type { BlotterCashEntry } from '@/store/blotter/types/BlotterCashEntry.ts';

type Props = {
  entry: BlotterCashEntry;
};

export const SwapFieldSet = ({ entry }: Props) => {
  return (
    <div className="container-fluid">
      <div className="row">
        <BlotterDetailsField singleColumn labelI18NKey="blotter.tab.Cash.details.account" value={entry.account} />
      </div>
      <div className="row">
        <BlotterDetailsField
          labelI18NKey="blotter.tab.Cash.details.clientWay"
          value={`${entry.way} ${entry.currencyPair}`}
        />
        <BlotterDetailsField
          labelI18NKey="blotter.tab.Cash.details.tradeDate"
          formatting="date"
          value={entry.execTime}
        />
      </div>
      <div className="row">
        <BlotterDetailsField
          labelI18NKey="blotter.tab.Cash.details.nearDate"
          formatting="date"
          value={entry.nearDate}
        />
        <BlotterDetailsField labelI18NKey="blotter.tab.Cash.details.farDate" formatting="date" value={entry.farDate} />
      </div>
      <div className="row">
        <BlotterDetailsField
          labelI18NKey="blotter.tab.Cash.details.dealtAmount"
          formatting="amount"
          currency={entry.dealtCurrency}
          value={entry.dealtAmount}
        />
        <BlotterDetailsField
          labelI18NKey="blotter.tab.Cash.details.dealtAmount"
          formatting="amount"
          currency={entry.dealtCurrency}
          value={entry.farDealtAmount}
        />
      </div>
      <div className="row">
        <BlotterDetailsField
          labelI18NKey="blotter.tab.Cash.details.nearPrice"
          formatting="rate"
          value={entry.nearRate}
        />
        <BlotterDetailsField labelI18NKey="blotter.tab.Cash.details.farPrice" formatting="rate" value={entry.farRate} />
      </div>
      <div className="row">
        <BlotterDetailsField
          singleColumn
          labelI18NKey="blotter.tab.Cash.details.swapPoints"
          formatting="points"
          value={entry.points}
        />
      </div>
    </div>
  );
};
